import { defineMessages } from 'react-intl';

const i18nMessages = defineMessages({
  home: { id: 'menu.home', defaultMessage: 'Home' },
  dashboard: { id: 'menu.dashboard', defaultMessage: 'Dashboard' },
  respondents: { id: 'menu.respondents', defaultMessage: 'Respondents' },
  listRespondents: {
    id: 'menu.respondents.list_respondents',
    defaultMessage: 'List Respondents',
  },
  addRespndent: { id: 'candidate.add', defaultMessage: 'Add Respondent' },
  importRespondents: {
    id: 'actions.import_respondents',
    defaultMessage: 'Import Respondents',
  },
  exportRespondents: {
    id: 'actions.export_respondents',
    defaultMessage: 'Export Respondents',
  },
  assessments: { id: 'menu.assessment', defaultMessage: 'Assessments' },
  listAssessments: {
    id: 'menu.assessment.list_assessments',
    defaultMessage: 'List Assessments',
  },
  superLink: { id: 'menu.assessment.superLinks', defaultMessage: 'SuperLinks' },
  listSuperLinks: {
    id: 'menu.assessment.superLink.list_superLinks',
    defaultMessage: 'List SuperLinks',
  },
  addSuperLink: {
    id: 'menu.assessment.superLink.add_superLink',
    defaultMessage: 'Add SuperLink',
  },
  assessmentTemplates: {
    id: 'menu.assessment.templates',
    defaultMessage: 'Assessment Templates',
  },
  listAssessmentTemplates: {
    id: 'menu.assessment.list_templates',
    defaultMessage: 'List Assessment Templates',
  },
  addAssessmentTemplate: {
    id: 'menu.assessment.add_template',
    defaultMessage: 'Add Assessment Template',
  },
  dataExport: {
    id: 'menu.assessment.data_export',
    defaultMessage: 'Export assessment data',
  },
  assessmentAnalysis: {
    id: 'menu.assessment.assessmentAnalysis',
    defaultMessage: 'Assessment Analyses',
  },
  listTeamReports: {
    id: 'menu.assessment.list_teamReports',
    defaultMessage: 'List Team Reports',
  },
  addTeamReport: {
    id: 'menu.assessment.add_teamReport',
    defaultMessage: 'Add Team Report',
  },
  jobProfiles: {
    id: 'menu.assessment.jobProfiles',
    defaultMessage: 'Job Profiles',
  },
  listJobProfiles: {
    id: 'menu.assessment.list_jobProfiles',
    defaultMessage: 'List Job Profiles',
  },
  addJobProfile: {
    id: 'menu.assessment.add_jobProfile',
    defaultMessage: 'Add Job Profile',
  },
  standardJobProfile: {
    id: 'menu.assessment.jobProfile.standard',
    defaultMessage: 'Standard',
  },
  superMatch: {
    id: 'menu.superMatch',
    defaultMessage: 'SuperMatch',
  },
  listSuperMatches: {
    id: 'menu.superMatches.list',
    defaultMessage: 'List SuperMatches',
  },
  listSuperProfiles: {
    id: 'menu.superProfiles.list',
    defaultMessage: 'List SuperProfiles',
  },
  addSuperProfile: {
    id: 'menu.superProfiles.add',
    defaultMessage: 'Add SuperProfile',
  },
  surveys: { id: 'menu.survey360', defaultMessage: 'Surveys' },
  listSurveys: {
    id: 'menu.surveys360.list_surveys',
    defaultMessage: 'List Surveys',
  },
  surveyTemplates: {
    id: 'menu.surveys360.surveyTemplates',
    defaultMessage: 'Survey Templates',
  },
  listSurveyTemplates: {
    id: 'menu.survey360.list_templates',
    defaultMessage: 'List Survey Templates',
  },
  addSurveyTemplate: {
    id: 'menu.survey360.add_surveyTemplate',
    defaultMessage: 'Add Survey Template',
  },
  superSurveys: {
    id: 'menu.survey360.superSurveys',
    defaultMessage: 'SuperSurveys',
  },
  listSuperSurveys: {
    id: 'menu.survey360.list_superSurveys',
    defaultMessage: 'List SuperSurveys',
  },
  addSuperSurvey: {
    id: 'menu.survey360.add_superSurvey',
    defaultMessage: 'Add SuperSurvey',
  },
  surveyAnalysis: {
    id: 'menu.survey360.surveyAnalysis',
    defaultMessage: 'Survey Analyses',
  },
  listExecutiveReports: {
    id: 'menu.survey360.list_executiveReports',
    defaultMessage: 'List Executive Reports',
  },
  addExecutiveReport: {
    id: 'menu.survey360.add_executiveReport',
    defaultMessage: 'Add Executive Report',
  },
  accountManagement: {
    id: 'menu.accountManagement',
    defaultMessage: 'Account management',
  },
  users: { id: 'menu.accountManagement.users', defaultMessage: 'Users' },
  listUsers: {
    id: 'menu.accountManagement.list_users',
    defaultMessage: 'List users',
  },
  addUser: {
    id: 'menu.accountManagement.add_user',
    defaultMessage: 'Add user',
  },
  listUserInvitations: {
    id: 'menu.accountManagement.list_userInvitations',
    defaultMessage: 'List user invitations',
  },
  accounts: {
    id: 'menu.accountManagement.accounts',
    defaultMessage: 'Accounts',
  },
  settings: {
    id: 'menu.accountManagement.settings',
    defaultMessage: 'Settings for this account',
  },
  listFamilyAccounts: {
    id: 'menu.accountManagement.list_familyAccounts',
    defaultMessage: 'List Family Accounts',
  },
  addFamilyAccount: {
    id: 'menu.accountManagement.add_familyAccount',
    defaultMessage: 'Add Family Account',
  },
  addClientAccount: {
    id: 'menu.accountManagement.add_clientAccount',
    defaultMessage: 'Add Client account',
  },
  addCPAccount: {
    id: 'menu.accountManagement.add_cpAccount',
    defaultMessage: 'Add CP account',
  },
  addMCPAccount: {
    id: 'menu.accountManagement.add_mcpAccount',
    defaultMessage: 'Add MCP account',
  },
  addGSCAccount: {
    id: 'menu.accountManagement.add_gscAccount',
    defaultMessage: 'Add GSC account',
  },
  addGPAccount: {
    id: 'menu.accountManagement.add_gpAccount',
    defaultMessage: 'Add GP account',
  },
  creditsManagement: {
    id: 'menu.creditsManagement',
    defaultMessage: 'Credits',
  },
  transferCredits: {
    id: 'menu.creditsManagement.transfer_credits',
    defaultMessage: 'Transfer Credits',
  },
  transferLog: {
    id: 'menu.credits_management.transferLog',
    defaultMessage: 'Transfer log',
  },
  consumptionLog: {
    id: 'menu.creditsManagement.consumptionLog',
    defaultMessage: 'Consumption log',
  },
  buyCredits: {
    id: 'menu.creditsManagement.buy-credits',
    defaultMessage: 'Buy Credits',
  },
  organisationManagement: {
    id: 'menu.organisationManagement',
    defaultMessage: 'Organisation management',
  },
  overview: {
    id: 'menu.organisationManagement.overview',
    defaultMessage: 'Overview',
  },
  businessCenter: {
    id: 'menu.organisationManagement.business-center',
    defaultMessage: 'Business Center',
  },
  noLimit: {
    id: 'menu.noLimit',
    defaultMessage: 'NoLimit',
  },
  gpiPartners: {
    id: 'menu.gpi-partners',
    defaultMessage: 'GPI Partners',
  },
  clients: {
    id: 'menu.clients',
    defaultMessage: 'Clients',
  },
  inviteNewClient: {
    id: 'menu.invite-new-client',
    defaultMessage: 'Invite new NoLimit client',
  },
  manageNoLimitPaidByMe: {
    id: 'menu.manage-no-limit-paid-by-me',
    defaultMessage: 'Manage NoLimit paid by me',
  },
  reactivateNoLimitPaidByMe: {
    id: 'menu.reactivate-no-limit-paid-by-me',
    defaultMessage: '(Re)activate NoLimit paid by me',
  },
  noLimitInvoicesPaidByMe: {
    id: 'menu.no-limit-invoices-paid-by-me',
    defaultMessage: 'NoLimit invoices paid by me',
  },
  inviteNewGpiPartner: {
    id: 'menu.invite-new-gpi-partner',
    defaultMessage: 'Invite new GPI Partner',
  },
  commission: {
    id: 'menu.commission',
    defaultMessage: 'Commission',
  },
  agreedCommission: {
    id: 'menu.agreed-commission',
    defaultMessage: 'Agreed commission',
  },
  settledCommission: {
    id: 'menu.settled-commission',
    defaultMessage: 'Settled commission',
  },
  wallet: {
    id: 'menu.wallet',
    defaultMessage: 'Wallet',
  },
  invoiceCommission: {
    id: 'menu.invoice-commission',
    defaultMessage: 'Invoice commission',
  },
  manage: {
    id: 'menu.manage',
    defaultMessage: 'Manage subscription',
  },
  buyOrReactivate: {
    id: 'menu.buy-or-reactivate',
    defaultMessage: 'Reactivate stopped subscription',
  },
  invoices: {
    id: 'menu.invoices',
    defaultMessage: 'Invoices',
  },
  listInvitations: {
    id: 'menu.organisationManagement.list_invitations',
    defaultMessage: 'List invitations',
  },
  listOrganisation: {
    id: 'menu.organisationManagement.list_organisation',
    defaultMessage: 'List Organisation',
  },
  updateDimensions: {
    id: 'menu.organisationManagement.update_dimensions',
    defaultMessage: 'Update Dimensions',
  },
  transferDemoCredits: {
    id: 'menu.organisationManagement.transfer_demoCredits',
    defaultMessage: 'Transfer Demo Credits',
  },
  demoCreditsLog: {
    id: 'menu.organisationManagement.demoCreditsLog',
    defaultMessage: 'Demo Credits log',
  },
  creditPlans: {
    id: 'menu.organisationManagement.creditPlans',
    defaultMessage: 'Credit Plans',
  },
  documents: { id: 'menu.documents', defaultMessage: 'Documents' },
  documentation: {
    id: 'menu.documents.documentation',
    defaultMessage: 'Documentation',
  },
  GDPR: {
    id: 'menu.documents.gdpr.selling.servicing',
    defaultMessage: 'GDPR when selling and servicing',
  },
  releaseNotes: {
    id: 'menu.documents.release.notes',
    defaultMessage: 'Release Notes – 09 NOV 2019',
  },
  importantDocuments: {
    id: 'menu.documents.importantDocuments',
    defaultMessage: 'Important Documents',
  },
  quickGuides: {
    id: 'menu.documents.documentation.quickGuides',
    defaultMessage: 'Quick Guides',
  },
  ariQuickGuide: {
    id: 'menu.documents.documentation.ariQuickGuide',
    defaultMessage: 'ARI Quick Guide',
  },
  gdprWhenSellingAndServicing: {
    id: 'menu.documents.documentation.gdprWhenSellingAndServicing',
    defaultMessage: 'GDPR when selling and servicing ',
  },
  partnerResources: {
    id: 'menu.documents.documentation.partnerResources',
    defaultMessage: 'Partner Resources',
  },
  supportProcedure: {
    id: 'menu.documents.documentation.supportProcedure',
    defaultMessage: 'Support Procedure',
  },
  userTermsOfUse: { id: 'msg.termsOfUse', defaultMessage: 'User Terms of Use' },
  privacyPolicy: { id: 'msg.privacyPolicy', defaultMessage: 'Privacy Policy' },
  termsOfServiceOnlinePurchases: {
    id: 'msg.termsOfServiceOnlinePurchases',
    defaultMessage: 'Terms of Service - online purchases',
  },
  serviceLevelAgreement: {
    id: 'msg.serviceLevelAgreement',
    defaultMessage: 'Service Level Agreement',
  },
  dataProcessingAgreement: {
    id: 'msg.dataProcessingAgreement',
    defaultMessage: 'Data Processing Agreement',
  },
  clientTermsOfUse: {
    id: 'msg.clientTermsOfUse',
    defaultMessage: 'Client Terms of Use',
  },
  gpAgreement: {
    id: 'msg.gpAgreement',
    defaultMessage: 'GP Agreement',
  },
  updateCompanyData: {
    id: 'menu.accounts.update-invoice-address-and-other-company-data',
    defaultMessage: 'Update Invoice Address and other Company Data',
  },
  updateBrandingData: {
    id: 'menu.accounts.update-branding-data',
    defaultMessage: 'Update Branding Data',
  },
  commercialAgreements: {
    id: 'menu.accounts.commercial-agreements',
    defaultMessage: 'Commercial Agreements',
  },
  addCommercialAgreement: {
    id: 'menu.accounts.add-commercial-agreement',
    defaultMessage: 'Add Agreement',
  },
  listCommercialAgreements: {
    id: 'menu.accounts.list-commercial-agreements',
    defaultMessage: 'List Agreements',
  },
  addItemBankAssessmentContent: {
    id: 'menu.item-bank-management.add-itembank-assessment-content',
    defaultMessage: 'Add ItemBank Assessment Content',
  },
  addItemBankSurveyContent: {
    id: 'menu.item-bank-management.add-itembank-survey-content',
    defaultMessage: 'Add ItemBank Survey Content',
  },
  updateTranslations: {
    id: 'menu.item-bank-management.update-translations',
    defaultMessage: 'Update Translations',
  },
  updateCustomTranslations: {
    id: 'menu.item-bank-management.update-custom-translations',
    defaultMessage: 'Update Custom Translations',
  },
  surveyCustomTranslations: {
    id: 'menu.item-bank-management.survey-custom-translations',
    defaultMessage: 'Survey Custom Translations',
  },
  assessmentCustomTranslations: {
    id: 'menu.item-bank-management.assessment-custom-translations',
    defaultMessage: 'Assessment Custom Translations',
  },
  standardTranslations: {
    id: 'menu.item-bank-management.standard-translations',
    defaultMessage: 'Standard Translations',
  },
  customTranslations: {
    id: 'menu.item-bank-management.custom-translations',
    defaultMessage: 'Custom Translations',
  },
  enableContent: {
    id: 'menu.item-bank-management.enable-content',
    defaultMessage: 'Enable Content',
  },
  itemBankManagement: {
    id: 'menu.item-bank-management.item-bank-management',
    defaultMessage: 'ItemBank Management',
  },
});

export default i18nMessages;
